import axios from "axios";
import qs from "qs";
import router from '../router'
import store from '../store'
import { Message, Loading } from 'element-ui';

let baseURL
// 判断开发环境（一般用于本地代理）
if (process.env.NODE_ENV === 'development') {      // 开发环境
  baseURL = window.APIURL.devUrlApi
} else {                                           // 生产环境
  baseURL = window.APIURL.prodUrlApi
}

/****** 创建axios实例 ******/
const service = axios.create({
  withCredentials: true,
  baseURL: baseURL,  // api的base_url
  timeout: 50000  // 请求超时时间
});


let loading;        //定义loading变量
function startLoading() {    //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.3)'
  })
}

function endLoading() {    //使用Element loading-close 方法
  loading.close()
}

let needLoadingRequestCount = 0

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}


/****** request拦截器==>对请求参数做处理 ******/
service.interceptors.request.use(config => {

  //打开预加载
  if (config.showLoading) {
    showFullScreenLoading();
  }
  config.headers['Content-Type'] = config.type === 'body' ? 'application/json' : 'application/x-www-form-urlencoded;charset=UTF-8';
  config.headers['Authorization'] = JSON.parse(LocalStorage.getItem('obj')) ? JSON.parse(LocalStorage.getItem('obj')).authToken : '';
  config.headers['x-requested-with'] = 'XMLHttpRequest';
  if (LocalStorage.getItem('obj') && JSON.parse(LocalStorage.getItem('obj')).vdnId && (!config.params || !config.params.vdnId)) {
    if (config.url.indexOf('vdnId') > -1) {

    } else {
      config.url = config.url + '?vdnId=' + JSON.parse(LocalStorage.getItem('obj')).vdnId
    }
  }
  return config;
}, error => {  //请求错误处理
  Message({
    message: error,
    type: 'error'
  });
  Promise.reject(error)
});


/****** respone拦截器==>对响应做处理 ******/
service.interceptors.response.use(
  response => {  //成功请求到数据

    //关闭预加载
    if (response.config.showLoading) {
      tryHideFullScreenLoading();
    }
    if (response.status === 200) {
      if (response.data.retCode === 105 || response.data.retCode === 106 || response.data.retCode === 109) {//TOKEN失效或者过期
        //console.log(this.authToken);
        if (LocalStorage.getItem("obj")) {
          LocalStorage.removeItem('obj');
          LocalStorage.removeItem('getPublicKey');
        }
        console.log('listRequest触发退出......')
        router.push('/');
      }
      return response.data;

    } else {
      Message({
        message: response.statusText,
        type: 'error'
      });
    }
  },
  error => {  //响应错误处理
    console.log('error');
    console.log(error);

    let stack = new Error(error).stack;
    if (stack.indexOf('403') > -1) {
      console.warn('用户无权访问getNoticePublishList接口');
    } else {
      Message({
        message: '网络异常，请稍后再试！',
        type: 'error'
      });
    }

    try {
      //关闭预加载
      if (response.config.showLoading) {
        tryHideFullScreenLoading();
      }
      return Promise.reject(error)
    } catch (err) {
      tryHideFullScreenLoading();
    }

  }
);
export default service;



// WEBPACK FOOTER //
// ./src/http/listRequest.js